enum InvoicingAndPaymentCollectionMethod {
    OffSystem, MonthlyInvoiceManualPayment, MonthlyInvoiceDirectDebitPayment, MonthlyInvoiceInlineCollection
}

export {InvoicingAndPaymentCollectionMethod};